import { firebaseDb as db } from '../../firebase'

import { asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../../actions'
import { Method, cloudFunctionRequest } from '../../cloudFunction'

export const hubspotGetAcessToken = (code, redirectUri, projectId, userToken) => {
  return dispatch => {
    dispatch(asyncRequest('hubspotGetAcessToken'))

    cloudFunctionRequest('integrations/hubspot/oauth/getAccessToken', Method.POST, {
      code,
      redirectUri,
      projectId,
      userToken
    })
      .then(response => {
        console.log('getAcessToken - RESPONSE: ', response)
        dispatch(asyncSuccess('hubspotGetAcessToken', { projectId, response }))
        dispatch(cleanMessages())
      })
      .catch(error => {
        console.log('getAcessToken - ERROR: ', error)
        dispatch(asyncFail('hubspotGetAcessToken', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const hubspotVerifyConnection = (projectId, userToken) => {
  return dispatch => {
    dispatch(asyncRequest('hubspotVerifyConnection'))

    cloudFunctionRequest('integrations/hubspot/verifyConnection', Method.POST, {
      projectId,
      userToken
    })
      .then(response => {
        console.log('verifyConnection - RESPONSE: ', response)
        dispatch(asyncSuccess('hubspotVerifyConnection', { projectId, response }))
        dispatch(cleanMessages())
      })
      .catch(error => {
        console.log('verifyConnection - ERROR: ', error)
        dispatch(asyncFail('hubspotVerifyConnection', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const hubspotPutContact = (projectId, userToken, contact, project) => {
  return dispatch => {
    dispatch(asyncRequest('hubspotPutContact', { contactId: contact.id }))

    cloudFunctionRequest('integrations/hubspot/putContact', Method.POST, {
      projectId,
      userToken,
      contact,
      project
    })
      .then(response => {
        console.log('putContact - RESPONSE: ', response)
        dispatch(asyncSuccess('hubspotPutContact', { response }, 'Contact successfully sent to HubSpot'))
        dispatch(cleanMessages())
      })
      .catch(error => {
        console.log('putContact - ERROR: ', error)
        dispatch(asyncFail('hubspotPutContact', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const hubspotDisconnectIntegration = projectId => {
  return dispatch => {
    dispatch(asyncRequest('hubspotDisconnectIntegration'))

    db
      .collection('projects')
      .doc(projectId)
      .update({
        'usedIntegrations.hubspot': false
      })
      .then(response => {
        dispatch(asyncSuccess('hubspotDisconnectIntegration', { projectId, response }))
        dispatch(cleanMessages())
      })
      .catch(error => {
        dispatch(asyncFail('hubspotDisconnectIntegration', error.code))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/integrations/hubspot.js